const isProduction = process.env.NODE_ENV === "production";

const logAnalytics = (functionName, event, properties) => {
  if (!isProduction) {
    console.info(`analytics.js :: ${functionName} :: `, event, properties);
  }
};

export const trackEvent = (event, properties) => {
  logAnalytics("trackEvent", event, properties);

  window?.gtag && window.gtag("event", event, properties);
  window?.posthog && window.posthog.capture(event, properties);
};

export const identify = (properties) => {
  logAnalytics("identify", properties, null);

  if (window?.gtag) {
    Object.entries(properties).forEach(([key, value]) => {
      window.gtag("config", process.env.GATSBY_GA4_MEASUREMENT_ID, {
        user_properties: {
          [key]: value,
        },
      });
    });
  }

  if (window?.posthog) {
    const phDistinctId = window.posthog?.get_distinct_id?.();
    phDistinctId && window.posthog.identify(phDistinctId, properties);
  }
};

export const trackPageView = (location) => {
  logAnalytics("trackPageView", location.pathname, null);

  window?.gtag &&
    window.gtag("config", process.env.GATSBY_GA4_MEASUREMENT_ID, {
      page_title: document.title,
      page_path: location.pathname + location.search + location.hash,
    });

  window.wisepops && window.wisepops("pageview");
};

export const trackBingConversion = (event, properties = {}) => {
  logAnalytics("trackBingConversion", event, properties);

  window.uetq = window.uetq || [];
  window.uetq.push("event", event, properties);
};
